import createHistory from 'history/createHashHistory';

// Create a history of your choosing (we're using a browser history in this case)
export const history = createHistory();



// WEBPACK FOOTER //
// ./src/dashboards_redux/router/history.jsx